import PropTypes from 'prop-types';

import Addon from './AddOn';

const Category = PropTypes.shape({
  description: PropTypes.string,
  max_quantity: PropTypes.number,
  min_quantity: PropTypes.number,
  name: PropTypes.string,
  option_group_id: PropTypes.number,
  options: PropTypes.arrayOf(Addon),
});

export default Category;
